import { render, staticRenderFns } from "./DrawingMoneyReview.vue?vue&type=template&id=56c7802a&scoped=true"
import script from "./DrawingMoneyReview.vue?vue&type=script&lang=js"
export * from "./DrawingMoneyReview.vue?vue&type=script&lang=js"
import style0 from "./DrawingMoneyReview.vue?vue&type=style&index=0&id=56c7802a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c7802a",
  null
  
)

export default component.exports